import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import moment from "moment";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import ContentIcon, { HEADING_SCHEDULES } from "ContentIcon";
import {
  fetchScheduleData,
  fetchSessionColors,
  openTrackModal,
  initiateFetchData,
  sessionWeekDays,
  eventDefaultTrack,
  selectScheduleDate,
  updateSessionZoom,
  manageNoTrack,
} from "ContentActions";
import {
  fetchEventDetails,
  fetchUsersCategory,
  fetchTotalUsers,
} from "DashboardUserAction";
import { fetchAllTickets, fetchSettings } from "TicketAction";
import { fetchUserInterests } from "ActionsMessage";
import { showError } from "ReduxErrorBar";
import { DEVELOPMENT_TYPE, screenHeightLeftFromTop } from "Constants";
import { MIN_ZOOM, MAX_ZOOM, HEIGHT_PER_HOUR } from "ScheduleConstants";
import ScheduleHeaderButtons from "./header-buttons";
import ScheduleDatesList from "./schedule-dates-list";
import TimeSlot from "./schedule_timeslots";
import ScheduleTrack from "./schedules_track";
import ScheduleTrackTitle from "./schedule_track_title";
import Loader from "Loader";
import LocaleStrings from "Languages";

class Schedules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      executed: false,
      loading: true,
      desc: LocaleStrings.preparingSchedules,
    };
  }

  componentDidMount() {
    this.props.actions.initiateFetchData();
    this.props.actions.fetchAllTickets(this.props.session, () => {});
    this.props.actions.fetchEventDetails(this.props.session, () => {});
    this.props.actions.fetchUsersCategory(this.props.session, () => {});
    this.props.actions.fetchSettings(this.props.session, () => {});
    this.props.actions.fetchUserInterests(this.props.session);
    this.props.actions.fetchTotalUsers(this.props.session, () => {});

    if (DEVELOPMENT_TYPE === "koachify") {
      var today = moment();
      var weekStart = today.clone().startOf("isoWeek");
      var weekEnd = today.clone().endOf("isoWeek");

      var weekdays = [];
      for (var i = 0; i <= 6; i++) {
        var date = moment(weekStart).add(i, "days").format("YYYY-MM-DD");
        var obj = {
          scheduledateid: date,
          scheduledate: date,
        };
        weekdays.push(obj);
      }

      // Setting today date as selected date firstime
      var match = _.filter(weekdays, (obj) => {
        return obj.scheduledate == today.format("YYYY-MM-DD");
      });
      if (match.length > 0) {
        this.props.actions.selectScheduleDate(match[0]);
      }

      this.props.actions.sessionWeekDays(weekdays);
      this.props.actions.eventDefaultTrack(this.props.session);
    }

    if (this.props.contentAvailable || this.props.source === "ticket_wizard") {
      this.props.actions.fetchSessionColors(this.props.session);

      setTimeout(() => {
        this.props.actions.fetchScheduleData(this.props.session, (callback) => {
          this.setState({ loading: false });
        });
      }, 100);
    } else {
      this.props.history.push("/dashboard/content");
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.contentAvailable !== this.props.contentAvailable) {
      if (nextProps.contentAvailable && !this.state.executed) {
        this.setState({ executed: true });
        this.props.actions.fetchSessionColors(this.props.session);

        setTimeout(() => {
          this.props.actions.fetchScheduleData(
            this.props.session,
            (callback) => {}
          );
        }, 100);
      } else {
        this.props.history.push("/dashboard/content");
      }
    }
  };

  onAddTrackClick() {
    this.props.actions.openTrackModal(true);
  }

  onEditTrackClick() {
    this.props.actions.openTrackModal(true);
  }

  additionCallback = () => {
    this.props.actions.fetchSessionColors(this.props.session);
    this.props.contentBoardStatus();

    setTimeout(() => {
      this.setState({ loading: true });
      this.props.actions.fetchScheduleData(this.props.session, (callback) => {
        this.setState({ loading: false });
      });
    }, 100);
  };

  handleZoom = (e) => {
    let zoom = e.target.value;
    // console.log("zoom :- ", zoom);

    let calHeight = HEIGHT_PER_HOUR * zoom;

    this.props.actions.updateSessionZoom({
      zoom: parseInt(zoom),
      height: calHeight,
    });
  };

  handleNoTrack = () => {
    let { session, selectedScheduleDate } = this.props;

    let tracksForSelectedDate =
      selectedScheduleDate.ScheduleDateToScheduletracks
        ? selectedScheduleDate.ScheduleDateToScheduletracks
        : [];
    // console.log("tracksForSelectedDate :- ", tracksForSelectedDate);
    // console.log("---------------------------------------------");

    // Check for selected date track required or not
    let checkTrackStatus = _.filter(tracksForSelectedDate, (o) => {
      return o.trackname === "##NOTRACK##";
    });

    let title = LocaleStrings.schedule_no_track_confirm_title;
    let subtitle = LocaleStrings.schedule_no_track_confirm_subtitle;
    if (checkTrackStatus.length > 0) {
      title = LocaleStrings.schedule_track_required_confirm_title;
      subtitle = LocaleStrings.schedule_track_required_confirm_subtitle;
    }

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{title}</h1>
            <p>{subtitle}</p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  this.props.actions.manageNoTrack(
                    session,
                    selectedScheduleDate.scheduledateid,
                    (response) => {
                      // console.log("Response :- ", response);
                      onClose();
                      if (response.status === 0) {
                        this.props.showError(response.data.message);
                      }
                    }
                  );
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  };

  renderTrackTitles() {
    var { selectedScheduleDate } = this.props;

    if (selectedScheduleDate.ScheduleDateToScheduletracks) {
      var items = selectedScheduleDate.ScheduleDateToScheduletracks.map(
        (track) => {
          return (
            <ScheduleTrackTitle key={track.scheduletrackid} track={track} />
          );
        }
      );
      return [
        items,
        <th
          className="schedule-table-header-th table-header-add-track"
          key="add_track"
          onClick={this.onAddTrackClick.bind(this)}
        >
          <img
            src="../../style/images/header-icons/plus.png"
            style={{ paddingRight: 10 }}
            aria-hidden="true"
          ></img>{" "}
          {LocaleStrings.schedule_addtrack}
        </th>,
      ];
    }
  }

  renderScheduleTracks() {
    var { selectedScheduleDate, timeSlots } = this.props;

    let tracksForSelectedDate =
      selectedScheduleDate.ScheduleDateToScheduletracks
        ? selectedScheduleDate.ScheduleDateToScheduletracks
        : [];

    // Check for selected date track required or not
    let checkTrackStatus = _.filter(tracksForSelectedDate, (o) => {
      return o.trackname === "##NOTRACK##";
    });

    if (DEVELOPMENT_TYPE === "koachify") {
      return (
        <ScheduleTrack
          track={{}}
          selectedDate={this.props.selectedScheduleDate}
        />
      );
    } else {
      var items = tracksForSelectedDate.map((track) => {
        return (
          <ScheduleTrack
            key={track.scheduletrackid}
            track={track}
            timeSlots={timeSlots}
          />
        );
      });
      if (checkTrackStatus.length > 0) {
        return items;
      } else {
        return [
          items,
          <ScheduleTrack
            key="blank_track"
            track={{ scheduletrackid: "-1" }}
            timeSlots={timeSlots}
          />,
        ];
      }
    }
  }

  handleEWeekdays = (action) => {
    let { dates } = this.props;
    var weekdays = [];
    var today = moment().format("YYYY-MM-DD");
    // console.log("action :- ", action);
    // console.log("dates :- ", dates);

    if (action === "next") {
      let day = _.last(dates);
      // console.log("last date :- ", day);
      var lastDate = moment(day.scheduledate);
      for (var i = 1; i <= 7; i++) {
        var date = moment(lastDate).add(i, "days").format("YYYY-MM-DD");
        var obj = {
          scheduledateid: date,
          scheduledate: date,
        };
        weekdays.push(obj);
      }
    } else {
      let day = _.first(dates);
      // console.log("first date :- ", day);
      var firstDate = moment(day.scheduledate);
      for (var i = 7; i >= 1; i--) {
        var date = moment(firstDate).subtract(i, "days").format("YYYY-MM-DD");
        var obj = {
          scheduledateid: date,
          scheduledate: date,
        };
        weekdays.push(obj);
      }
    }
    var match = _.filter(weekdays, (obj) => {
      return obj.scheduledate == today;
    });

    if (match.length > 0) {
      this.props.actions.selectScheduleDate(match[0]);
    } else {
      this.props.actions.selectScheduleDate(weekdays[0]);
    }

    // console.log("weekdays :- ", weekdays);
    this.props.actions.sessionWeekDays(weekdays);
  };

  render() {
    var {
      selectedScheduleDate,
      schedulesAvailable,
      deviceSize,
      sessionScreenZoom,
      timeSlots,
    } = this.props;
    var tracksAvailable =
      selectedScheduleDate.ScheduleDateToScheduletracks &&
      selectedScheduleDate.ScheduleDateToScheduletracks.length > 0;
    tracksAvailable = tracksAvailable && schedulesAvailable;
    // console.log("selectedScheduleDate :- ", selectedScheduleDate);

    let tracksForSelectedDate =
      selectedScheduleDate.ScheduleDateToScheduletracks
        ? selectedScheduleDate.ScheduleDateToScheduletracks
        : [];
    // console.log("tracksForSelectedDate :- ", tracksForSelectedDate);
    // console.log("---------------------------------------------");

    // Check for selected date track required or not
    let checkTrackStatus = _.filter(tracksForSelectedDate, (o) => {
      return o.trackname === "##NOTRACK##";
    });

    let zoomVal = !_.isEmpty(sessionScreenZoom)
      ? sessionScreenZoom.zoom
      : MIN_ZOOM;

    let heighPerHour = !_.isEmpty(sessionScreenZoom)
      ? sessionScreenZoom.height
      : HEIGHT_PER_HOUR;

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <ContentIcon heading={HEADING_SCHEDULES} />
          </div>

          <ScheduleHeaderButtons
            history={this.props.history}
            selectedScheduleDate={selectedScheduleDate}
            finishOperationsCallback={this.additionCallback}
          />
        </div>

        {this.state.loading ? (
          <div
            className="panel-body scrollable-content"
            style={{ height: deviceSize.height - screenHeightLeftFromTop }}
          >
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          </div>
        ) : (
          <div style={{ height: deviceSize.height - screenHeightLeftFromTop }}>
            {this.props.isFetching ? (
              <div />
            ) : (
              <>
                {DEVELOPMENT_TYPE === "koachify" ? (
                  <div
                    className="d-flex"
                    style={{ backgroundColor: "#f9fafc" }}
                  >
                    <button
                      className="btn-custom-white ml-15"
                      onClick={() => this.handleEWeekdays("previous")}
                    >
                      <span className="glyphicon glyphicon-chevron-left"></span>
                    </button>
                    <ScheduleDatesList />
                    <button
                      className="btn-custom-white"
                      onClick={() => this.handleEWeekdays("next")}
                    >
                      <span className="glyphicon glyphicon-chevron-right"></span>
                    </button>
                  </div>
                ) : (
                  <ScheduleDatesList />
                )}

                <div
                  className="track-content d-flex"
                  style={{
                    height: deviceSize.height - (screenHeightLeftFromTop + 60),
                  }}
                >
                  <div className="schedule-timeslot-container">
                    {DEVELOPMENT_TYPE === "koachify" ? (
                      <div style={{ verticalAlign: "top" }}>
                        <TimeSlot timeSlots={timeSlots} />
                      </div>
                    ) : DEVELOPMENT_TYPE === "eventify" ? (
                      <>
                        <div className="schedule-table-header-blank-th">
                          <button
                            className="btn btn-custom-white"
                            onClick={this.handleNoTrack}
                          >
                            {checkTrackStatus.length > 0
                              ? LocaleStrings.schedule_addtrack
                              : LocaleStrings.schedule_notrack}
                          </button>
                        </div>

                        {tracksAvailable ? (
                          <TimeSlot timeSlots={timeSlots} />
                        ) : (
                          ""
                        )}
                      </>
                    ) : null}
                  </div>

                  <div
                    className="schedule-list-container"
                    style={{
                      height:
                        timeSlots.length > 0
                          ? heighPerHour * timeSlots.length + 60
                          : 200,
                    }} // Multiply with total hrs range count, and for blank session list for selected date add static height
                  >
                    <table className="schedule-table">
                      {checkTrackStatus.length > 0 ? (
                        <thead>
                          <tr>
                            <div className="schedule-table-header-blank-th"></div>
                          </tr>
                        </thead>
                      ) : (
                        <thead>
                          <tr>
                            {/* {tracksAvailable ? (
                              <th className="schedule-table-header-blank-th">
                              &nbsp;
                              </th>
                            ) : null} */}

                            {this.renderTrackTitles()}
                          </tr>
                        </thead>
                      )}

                      <tbody>
                        <tr>
                          {/* {DEVELOPMENT_TYPE === "koachify" ? (
                            <td style={{ verticalAlign: "top" }}>
                              <TimeSlot />
                            </td>
                          ) : DEVELOPMENT_TYPE === "eventify" &&
                            tracksAvailable ? (
                            <td style={{ verticalAlign: "top" }}>
                              <TimeSlot />
                            </td>
                          ) : null} */}

                          {this.renderScheduleTracks()}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        <div className="session-zoom-container" style={{ width: 250 }}>
          <div className="slidecontainer">
            <input
              type="range"
              min={MIN_ZOOM}
              max={MAX_ZOOM}
              value={`${zoomVal}`}
              className="slider-btn"
              onChange={this.handleZoom}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  var availableFeatures = state.availableFeatures.filter(
    (feature) => feature.available
  );
  var selectedFeature = availableFeatures.filter(
    (feature) => feature.bsClass === state.selectedContentFeature.bsClass
  );
  var contentAvailable = selectedFeature.length > 0;

  // Code to get the session time range of selected date
  var dateTimes = {};
  var minTime = 0;
  var maxTime = 0;
  var minStartTime = (array, date) => {
    array.map((item) => {
      var onlyDate = item.starttime.substring(0, 10);

      let checkEndHr = parseInt(item.endtime.substring(11, 13));
      let checkEndMin = parseInt(item.endtime.substring(14, 16));

      let startHr = parseInt(item.starttime.substring(11, 13));
      let endHr = checkEndMin > 0 ? checkEndHr + 1 : checkEndHr;

      if (dateTimes[onlyDate]) {
        if (dateTimes[onlyDate].startHr > startHr) {
          dateTimes[onlyDate]["startHr"] = startHr;
        }
        if (dateTimes[onlyDate].endHr < endHr) {
          dateTimes[onlyDate]["endHr"] = endHr;
        }
      } else {
        dateTimes[onlyDate] = { startHr: startHr, endHr: endHr };
      }
    });

    // console.log("dateTimes : ", dateTimes);
    if (date in dateTimes) {
      minTime = dateTimes[date].startHr;
      maxTime = dateTimes[date].endHr;
    }
    // console.log(`Time range for date ${date} is : ${minTime} - ${maxTime}`);
  };

  var dateClickedOn = state.selectedScheduleDate.scheduledate;
  // console.log("selected date : ", dateClickedOn);

  // Get session time range of selected date
  var slots = [];
  if (state.scheduleData.payload.session_by_eventid) {
    minStartTime(state.scheduleData.payload.session_by_eventid, dateClickedOn);
    if (maxTime > 0) {
      for (var hour = minTime; hour <= maxTime; hour++) {
        slots.push(hour);
      }
    }
  }

  return {
    isFetching: state.scheduleData.isFetching,
    session: state.session,
    selectedScheduleDate: state.selectedScheduleDate,
    contentAvailable,
    schedulesAvailable:
      state.scheduleData.payload.session_by_eventid &&
      state.scheduleData.payload.session_by_eventid.length > 0,
    dates: state.sessionWeekdays,
    deviceSize: state.deviceSize,
    sessionScreenZoom: state.sessionScreenZoom,
    timeSlots: slots,
  };
}

var mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchScheduleData,
      openTrackModal,
      fetchSessionColors,
      initiateFetchData,
      fetchAllTickets,
      fetchEventDetails,
      fetchUsersCategory,
      sessionWeekDays,
      eventDefaultTrack,
      selectScheduleDate,
      fetchSettings,
      fetchUserInterests,
      updateSessionZoom,
      manageNoTrack,
      showError,
      fetchTotalUsers,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Schedules);
